import { Textarea, Label } from '@creanizer/ui'
import type { CharacterBeliefs } from '@creanizer/types'

interface BeliefsEditorProps {
  beliefs: CharacterBeliefs
  onChange: (beliefs: CharacterBeliefs) => void
}

export function BeliefsEditor({
  beliefs,
  onChange
}: BeliefsEditorProps) {
  const handleChange = (field: keyof CharacterBeliefs, value: string) => {
    onChange({
      ...beliefs,
      [field]: value
    })
  }

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="lifePhilosophy">人生哲学・座右の銘</Label>
        <Textarea
          id="lifePhilosophy"
          value={beliefs.lifePhilosophy || ''}
          onChange={(e) => handleChange('lifePhilosophy', e.target.value)}
          placeholder="例: 「諦めたらそこで試合終了」を信条としている"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="workBeliefs">仕事・活動に対する信念</Label>
        <Textarea
          id="workBeliefs"
          value={beliefs.workBeliefs || ''}
          onChange={(e) => handleChange('workBeliefs', e.target.value)}
          placeholder="例: どんな小さな仕事も手を抜かない、結果より過程を重視"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="worldview">社会観・世界観</Label>
        <Textarea
          id="worldview"
          value={beliefs.worldview || ''}
          onChange={(e) => handleChange('worldview', e.target.value)}
          placeholder="例: 人は基本的に善良だと信じている、世界は変えられると思っている"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="coreValues">大切にしている価値観</Label>
        <Textarea
          id="coreValues"
          value={beliefs.coreValues || ''}
          onChange={(e) => handleChange('coreValues', e.target.value)}
          placeholder="例: 家族との時間、仲間との絆、自由"
          rows={2}
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor="faith">信仰・思想（オプション）</Label>
        <Textarea
          id="faith"
          value={beliefs.faith || ''}
          onChange={(e) => handleChange('faith', e.target.value)}
          placeholder="例: 特定の神を信仰、無宗教だが精霊の存在を信じる"
          rows={2}
          className="mt-1"
        />
      </div>
    </div>
  )
}
